import React from 'react';
import { Zap, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#04060A] pt-16 pb-8 border-t border-white/10" data-id="element-153">
      <div className="container mx-auto px-4" data-id="element-154">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-155">
          <div data-id="element-156">
            <div className="flex items-center gap-2 mb-6" data-id="element-157">
              <Zap className="w-6 h-6 text-electric fill-electric" data-id="element-158" />
              <span className="font-bold text-xl tracking-tight" data-id="element-159">
                BIBLIOTECAS DIGITALES™
              </span>
            </div>
            <p className="text-textsecondary max-w-md mb-6" data-id="element-160">
              El sistema N°1 de autonomía eléctrica doméstica para propietarios
              argentinos.
              <br data-id="element-161" />
              <br data-id="element-162" />
              Porque resolver los problemas eléctricos de tu casa no debería
              depender de que alguien aparezca, cobre lo que quiera y no te
              explique nada.
            </p>
          </div>

          <div className="md:text-right flex flex-col md:items-end justify-center" data-id="element-163">
            <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors mb-4" data-id="element-164">
              <Mail className="w-5 h-5" data-id="element-165" /> soportebibliotecasdigitales@gmail.com
            </a>
            <a href="#" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors" data-id="element-166">
              <Globe className="w-5 h-5" data-id="element-167" /> www.bibliotecasdigitales.store
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-textsecondary/60" data-id="element-168">
          <p data-id="element-169">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
          <p className="flex items-center gap-1" data-id="element-170">
            <Zap className="w-3 h-3 text-electric" data-id="element-171" /> "La próxima falla
            eléctrica puede ser la que resolvés vos solo."
          </p>
        </div>
      </div>
    </footer>;
}